import { UserRoleEnum } from '@monetize/types/app';
import { ExperienceConfigurationKeys } from '@monetize/types/experience-config';
import lodashGet from 'lodash/get';
import isString from 'lodash/isString';
import { FunctionComponent as FC, useRef } from 'react';
import { BsFiletypeJson } from 'react-icons/bs';
import { ID_PREFIX_TO_CONFIG } from '../../constants/common';
import { useExperienceConfiguration } from '../../hooks/useExperienceConfiguration';
import { useAuth } from '../../services/auth0';
import { useEntityJsonViewer } from '../../services/entityJsonViewer';
import MCustomIconButton from './MCustomIconButton';
import { MTooltip } from './MTooltip';

interface EntityJsonViewerIconProps {
  json?: Record<string, unknown>;
}

export const EntityJsonViewerIcon: FC<EntityJsonViewerIconProps> = ({
  json,
}) => {
  const { openDrawer } = useEntityJsonViewer();
  const btnRef = useRef<HTMLButtonElement>(null);
  const { currentTenantUserHasRole } = useAuth();
  const { debugModeRoles } = useExperienceConfiguration(
    ExperienceConfigurationKeys.tenantSettings,
  );
  const canView =
    !debugModeRoles.length ||
    currentTenantUserHasRole(debugModeRoles as UserRoleEnum[]);

  if (!canView || !json) {
    return null;
  }

  const handleOnOpen = () => {
    let drawerTitle = 'Debug Entity JSON';
    const recordId = lodashGet(json, 'id');
    if (isString(recordId) && (recordId as string).includes('_')) {
      const [idPrefix] = (recordId as string).split('_');
      const idPrefixConfig = ID_PREFIX_TO_CONFIG[idPrefix];
      if (idPrefixConfig) {
        drawerTitle = `Debug ${idPrefixConfig.entityName} JSON`;
      }
    }
    openDrawer({
      title: drawerTitle,
      json,
      finalFocusRef: btnRef,
    });
  };

  return (
    <MTooltip label="Debug the record data. This is visible because you enabled the debug mode.">
      <MCustomIconButton
        ref={btnRef}
        containerSize={5}
        btnSize={4}
        variant="icon"
        verticalAlign="middle"
        icon={BsFiletypeJson}
        onClick={handleOnOpen}
        aria-label="View Entity Data"
      />
    </MTooltip>
  );
};
